import { ChevronLeft, ChevronRight } from "lucide-react";

/** Build page list with ellipsis, e.g. [1, "...", 4, 5, 6, "...", 10] */
const buildPages = (page, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(total - 1, page + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < total - 1) pages.push("...");
  pages.push(total);
  return pages;
};

const Pagination = ({ page, totalPages, onChange, prefix = "pagination" }) => {
  if (totalPages <= 1) return null;
  const btn = "inline-flex h-10 min-w-10 items-center justify-center rounded-full px-3 text-sm font-medium transition-all";
  return (
    <nav className="mt-12 flex flex-wrap items-center justify-center gap-2" aria-label="Navigasi halaman" data-testid={`${prefix}`}>
      <button
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        data-testid={`${prefix}-prev`}
        className={`${btn} gap-1 border border-slate-200 bg-white text-slate-600 hover:border-emerald-200 hover:text-emerald-700 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-slate-200 disabled:hover:text-slate-600`}
      >
        <ChevronLeft className="h-4 w-4" /> <span className="hidden sm:inline">Sebelumnya</span>
      </button>
      {buildPages(page, totalPages).map((p, i) =>
        p === "..." ? (
          <span key={`e${i}`} className="px-1 text-slate-400">…</span>
        ) : (
          <button
            key={p}
            onClick={() => onChange(p)}
            aria-current={p === page ? "page" : undefined}
            data-testid={`${prefix}-page-${p}`}
            className={`${btn} ${p === page ? "bg-emerald-600 text-white shadow-sm" : "border border-slate-200 bg-white text-slate-600 hover:border-emerald-200 hover:text-emerald-700"}`}
          >
            {p}
          </button>
        )
      )}
      <button
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        data-testid={`${prefix}-next`}
        className={`${btn} gap-1 border border-slate-200 bg-white text-slate-600 hover:border-emerald-200 hover:text-emerald-700 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-slate-200 disabled:hover:text-slate-600`}
      >
        <span className="hidden sm:inline">Berikutnya</span> <ChevronRight className="h-4 w-4" />
      </button>
    </nav>
  );
};

export default Pagination;
